import * as angular from 'angular';

import { TelemetryService } from '../Telemetry/mx-telemetry-service';

export const telemetryModule = angular
	.module('mx.sb.telemetry', [])
	.service('mx.sb.telemetry.service', TelemetryService)
	.run([
		'mx.sb.telemetry.service',
		function runModule(telemetryService: TelemetryService) {
			telemetryService.init();
		},
	]);
